import { useEffect, useState } from "react";

/**
 * CSS 미디어 쿼리 상태를 추적하는 훅
 * @param query - CSS 미디어 쿼리 문자열 (ex. "(max-width: 768px)")
 * @returns 미디어 쿼리가 일치하는지 여부
 */
export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState<boolean>(() => {
		// SSR 환경에서는 기본값 반환
		if (typeof window === "undefined") {
			return false;
		}
		return window.matchMedia(query).matches;
	});

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);

		// 현재 상태 설정
		setMatches(mediaQuery.matches);

		// 이벤트 리스너 함수
		const handleChange = (event: MediaQueryListEvent) => {
			setMatches(event.matches);
		};

		// 이벤트 리스너 등록
		mediaQuery.addEventListener("change", handleChange);

		// 클린업 함수
		return () => {
			mediaQuery.removeEventListener("change", handleChange);
		};
	}, [query]);

	return matches;
}

export default useMediaQuery;
